import { z } from 'zod';

/**
 * The operator app's test-workspace filter (IMM-593.2), shared by every
 * workspace-scoped operator list. Omitted or `false` HIDES rows whose workspace
 * is marked as a testing environment — the default is applied HERE, once, so a
 * caller that forgets the parameter can never re-mix test tenants into a list
 * and no presenter has to repeat it. `true` returns exactly what the list
 * returned before the filter existed.
 *
 * `z.stringbool()` rather than `z.coerce.boolean()`: the latter reads the URL
 * string `"false"` as `true`, which would turn an explicit opt-out into an
 * opt-in.
 *
 * Rows that resolve to NO workspace (an unresolved API call, a service key) are
 * not test data and are returned in both states.
 */
export const IncludeTestWorkspacesQuerySchema = z.object({
  includeTestWorkspaces: z.stringbool().default(false),
});
export type IncludeTestWorkspacesQuery = z.infer<typeof IncludeTestWorkspacesQuerySchema>;
